import { Button, Flex, message, Table, theme, Typography } from 'antd';
import Column from 'antd/es/table/Column';
import { FC } from 'react';
import { TransferRow } from './TransfersPage';
import { upperCaseFirstLetter } from '../libs/string';
import { useTransfer } from './useTransfer';
import { css } from '@emotion/css';
import { CopyOutlined } from '@ant-design/icons';

export const DestionationDetails: FC<{ transfer: TransferRow }> = ({ transfer }) => {
  const { token } = theme.useToken();
  const [messageApi, contextHolder] = message.useMessage();
  const query = useTransfer(transfer.id, transfer.type);
  const dataSource = [
    {
      key: 'Destination payment rail',
      value: upperCaseFirstLetter(transfer.destination_network),
    },
    {
      key: 'Destination currency',
      value: transfer?.destination_currency.toUpperCase(),
    },
  ];

  if (query.data?.offramp_transfer && Object.keys(query.data?.offramp_transfer).length) {
    dataSource.push(
      {
        key: 'Bank name',
        value: query.data.offramp_transfer.destination_bank_account.bank_name,
      },
      {
        key: 'Account holder type',
        value: upperCaseFirstLetter(query.data.offramp_transfer.destination_bank_account.account_holder_type),
      },
      {
        key: 'Account holder',
        value: query.data.offramp_transfer.destination_bank_account.account_holder_business_name
          ? query.data.offramp_transfer.destination_bank_account.account_holder_business_name
          : `${query.data.offramp_transfer.destination_bank_account.account_holder_first_name} ${query.data.offramp_transfer.destination_bank_account.account_holder_last_name}`,
      }
    );

    if (query.data.offramp_transfer.destination_bank_account.iban) {
      dataSource.push(
        {
          key: 'IBAN',
          value: query.data.offramp_transfer.destination_bank_account.iban.iban_number!,
        },
        {
          key: 'BIC code',
          value: query.data.offramp_transfer.destination_bank_account.iban.bic!,
        }
      );
    } else if (query.data.offramp_transfer.destination_bank_account.us) {
      dataSource.push(
        {
          key: 'Account number',
          value: query.data.offramp_transfer.destination_bank_account.us.account_number!,
        },
        {
          key: 'Routing number',
          value: query.data.offramp_transfer.destination_bank_account.us.routing_number!,
        }
      );
    } else if (query.data.offramp_transfer.destination_bank_account.international_wire) {
      dataSource.push(
        {
          key: 'Account number',
          value: query.data.offramp_transfer.destination_bank_account.international_wire.account_number!,
        },
        {
          key: 'Routing number',
          value: query.data.offramp_transfer.destination_bank_account.international_wire.routing_number || 'N/A',
        },
        {
          key: 'BIC code',
          value: query.data.offramp_transfer.destination_bank_account.international_wire.bic,
        }
      );
    }

    dataSource.push(
      {
        key: 'Account holder address',
        value: `${query.data.offramp_transfer.destination_bank_account.account_holder_address.street_line_1}, ${query.data.offramp_transfer.destination_bank_account.account_holder_address.city}, ${query.data.offramp_transfer.destination_bank_account.account_holder_address.country}, ${query.data.offramp_transfer.destination_bank_account.account_holder_address.postal_code}`,
      },
      {
        key: 'Transfer Purpose',
        value: query.data.offramp_transfer.transfer_purpose || 'N/A',
      }
    );
  } else if (query.data?.onramp_transfer && Object.keys(query.data?.onramp_transfer).length) {
    dataSource.push({
      key: 'Destination wallet address',
      value: `${query.data.onramp_transfer?.destination_address}`,
    });
  }

  return (
    <>
      {contextHolder}
      <Table
        loading={query.isPending || query.isFetching}
        title={() => {
          return (
            <Typography.Title style={{ margin: 0 }} level={5}>
              Destination Details
            </Typography.Title>
          );
        }}
        size="small"
        showHeader={false}
        rowHoverable={false}
        pagination={false}
        dataSource={dataSource}
      >
        <Column
          key="key"
          width={250}
          render={(v) => {
            return v.key;
          }}
        />

        <Column
          key="value"
          render={(v) => {
            const subHeaderStyles = css`
              color: ${token.colorTextTertiary};
            `;
            if (
              [
                'IBAN',
                'BIC code',
                'Account number',
                'Routing number',
                'Account holder',
                'Account holder address',
              ].includes(v.key)
            ) {
              return (
                <Flex align="center" gap={'small'}>
                  {v.value}
                  <Button
                    type="text"
                    className={subHeaderStyles}
                    size="small"
                    icon={<CopyOutlined width={16} />}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigator.clipboard.writeText(v.value);
                      messageApi.success('Copied to clipboard');
                    }}
                  />
                </Flex>
              );
            }

            return v.value;
          }}
        />
      </Table>
    </>
  );
};
